import React, { useState } from 'react'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import BertholdTitle from 'src/components/atoms/bertholdTitle'
import { generateRandomId } from 'src/utils/domHelper'
import * as GlobalStyles from 'src/styles/global.module.scss'

import { Link } from 'gatsby'
import { PrismicLinkType } from 'src/typings/generated/graphql'
import * as Styles from './descriptiveCardLink.module.scss'

type Props = {
  title?: string
  image?: IGatsbyImageData
  alt: string
  descriptionDisplay?: 'on' | 'toggle' | string
  link?: PrismicLinkType
  onButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const DescriptiveCardLink = ({
  title = '',
  image,
  alt,
  link,
  descriptionDisplay = 'toggle',
  onButtonClick,
}: Props) => {
  const [open, setOpen] = useState(descriptionDisplay === 'on')

  const descriptiveCardClass = Styles.descriptiveCard

  const descriptionId = `card-description-${generateRandomId()}`

  const renderCopy = () => {
    if (descriptionDisplay === 'toggle') {
      return (
        <div
          className={`${Styles.copy} $`}
          role="button"
          aria-controls={descriptionId}
          onClick={() => setOpen(!open)}
          onKeyDown={e => {
            if (e.code === 'Enter') setOpen(!open)
          }}
          tabIndex={0}
        >
          {title && (
            <div className={Styles.titleContainer}>
              <h3 className={`${Styles.headline} ${Styles.hasCarrot}`}>
                {BertholdTitle({ text: title })}
              </h3>
              <button
                type="button"
                className={`${GlobalStyles.redButtonResponsive} ${Styles.learnMoreButton}`}
                onClick={onButtonClick}
              >
                Learn More
              </button>
            </div>
          )}
        </div>
      )
    }

    return (
      <div className={Styles.copy}>
        {title && (
          <h3 className={`${Styles.headline} ${Styles.hasCarrot}`}>
            {BertholdTitle({ text: title })}
          </h3>
        )}
      </div>
    )
  }

  return (
    <Link
      to={link?.url || '#'}
      target={link?.target || '_self'}
      className={descriptiveCardClass}
    >
      <div className={Styles.imageWrapper}>
        {!!image && (
          <GatsbyImage className={Styles.image} image={image} alt={alt ?? ''} />
        )}
      </div>
      {renderCopy()}
    </Link>
  )
}

export default DescriptiveCardLink
